export default {"src":"/_next/static/media/safety-dog.d187103f.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};